<div class="sop-right-column-container">
    <ng-container>
        <div class="create-btn-container" *ngIf="formData == null && !isCreatingNewSop">
            <button class="mat-button mat-primary mat-raised-button create-btn" (click)="createNewSop()"> Create Digital
                SOP
            </button>
        </div>
        <!-- <button  class="mat-button mat-primary mat-raised-button" type="button" (click)="deleteSop(formData?.id)">
            <mat-icon class="delete-icon" *ngIf="formData?.id" matTooltip="Delete SOP" (click)="deleteSop(formData?.id)">delete</mat-icon>
        </button> -->
        <div class="sop-details-container" *ngIf="isCreatingNewSop" [formGroup]="sopDetailsForm">
            <div class="fields-container">
                <div class="details-input-field">
                    <span>SOP Name</span>
                    <input matInput formControlName="name" placeholder="SOP Name"
                        [ngClass]="{ 'input-error':sopDetailsForm.get('name')?.hasError('required') }">
                    <span class="error-msg" *ngIf="sopDetailsForm.get('name')?.hasError('required')"> Name is
                        required.</span>
                </div>
                <div class="details-input-field">
                    <span>Part Number</span>
                    <input matInput formControlName="partNo" placeholder="Part Number"
                        [ngClass]="{ 'input-error': sopDetailsForm.get('partNo')?.hasError('required') }">
                    <span class="error-msg" *ngIf="sopDetailsForm.get('partNo')?.hasError('required')"> Part Number is
                        required.</span>
                </div>
                <div class="details-input-field">
                    <span>Station</span>
                    <input matInput formControlName="station" placeholder="Enter Station"
                        [ngClass]="{ 'input-error': sopDetailsForm.get('station')?.hasError('required') }">
                    <span class="error-msg" *ngIf="sopDetailsForm.get('station')?.hasError('required')"> Station is
                        required.</span>
                </div>
            </div>

            <div class="video-field-container">
                <span>Video</span>
                <!-- Show HLS player if editing an existing SOP -->
                <div *ngIf="currentSop?.videoProcessing === 'COMPLETED' || formData?.videoProcessing === 'COMPLETED'; else showConditionalContent"
                    class="video-container mt-3 mb-3 container d-flex align-items-center justify-content-center">
                    <!-- <video #videoPlayer width="640" height="360" controls muted></video> -->
                    <!-- autoplay -->
                    <video #target class="video-js vjs-default-skin" controls preload="auto" width="640" height="264">

                    </video>
                </div>
                <ng-template #showConditionalContent>
                    <div *ngIf="currentSop?.videoProcessing === 'IN-PROGRESS' || isProcessing; else checkIfFailed"
                        class="video-container justify-content-center">
                        <mat-spinner diameter="40"></mat-spinner>
                        <span class="ms-2">{{isProcessing ? 'Uploading Video...' : 'Processing video...'}}</span>
                    </div>
                </ng-template>
                <ng-template #checkIfFailed>
                    <div *ngIf="currentSop?.videoProcessing === 'FAILED'; else uploadSection" class="video-container">
                        <span class="text-danger">⚠️ Video processing failed. Please try uploading again.</span>
                        <input type="file" #fileInput accept="video/mp4,video/webm,video/ogg" style="display: none"
                            (change)="onVideoSelected($event)" />
                        <button class="mat-button mat-raised-button" (click)="fileInput.click()"> Upload Video
                        </button>
                        <span class="text-sm text-gray-500">MP4, MOV or WebM files</span>
                    </div>
                </ng-template>
                <ng-template #uploadSection>
                    <div *ngIf="isCreatingNewSop" class="video-container">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-upload mx-auto h-12 w-12 text-gray-400">
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                            <polyline points="17 8 12 3 7 8"></polyline>
                            <line x1="12" x2="12" y1="3" y2="15"></line>
                        </svg>
                        <!-- Hidden file input -->
                        <input type="file" #fileInput accept="video/mp4,video/webm,video/ogg" style="display: none"
                            (change)="onVideoSelected($event)" />
                        <button class="mat-button mat-raised-button" (click)="fileInput.click()"> Upload Video
                        </button>
                        <span class="text-sm text-gray-500">MP4, MOV or WebM files</span>
                    </div>
                </ng-template>
            </div>
        </div>
        <div class="sop-instructions-container"
            *ngIf="isCreatingNewSop && sopSteps?.length === 0; else showStepsContainer">
            <div class="instructions">
                <span class="heading">Instructions</span>
                <div class="sop-instructions-content-container">
                    <ul>
                        <li>
                            <strong>Enter</strong> the <span class="highlight">SOP Name</span> and <span
                                class="highlight">Part
                                Number</span> in the input fields.
                        </li>
                        <li>
                            <strong>Upload</strong> the video corresponding to the selected part number.
                        </li>
                        <li>
                            Wait till the video gets uploaded and processed.
                        </li>
                        <li>
                            <strong>Click on the video timeline</strong> to add step markers. Each click creates a new
                            SOP
                            step.
                        </li>
                        <li>
                            <strong>Add detailed instructions</strong> once step is created
                        </li>
                    </ul>
                </div>
            </div>
            <button *ngIf="formData?.id" style="align-self: flex-end;background-color: #f55656;"
                class="mat-button mat-primary mat-raised-button" (click)="deleteSop(formData?.id)">Delete
                SOP
            </button>
        </div>
        <ng-template #showStepsContainer>
            <div class="steps-main-container"
                *ngIf="isCreatingNewSop && sopSteps?.length > 0 && sopStepForm?.get('steps')" [formGroup]="sopStepForm">
                <div class="steps-scrollable-container" formArrayName="steps">
                    <div class="step-card-container" *ngFor="let step of steps.controls; let i = index"
                        [formGroupName]="i">
                        <div class="header">
                            <div class="input-field">
                                <span>Work Sequence</span>
                                <input matInput formControlName="stepName" placeholder="Enter Sequence Name"
                                    [ngClass]="{ 'input-error': step.get('stepName')?.hasError('required') && step.get('stepName')?.touched}">
                                <span class="error-msg"
                                    *ngIf="step.get('stepName')?.hasError('required') && step.get('stepName')?.touched">
                                    Work Sequence is required.</span>
                            </div>
                            <div class="input-field time">
                                <span>Start Time</span>
                                <input matInput formControlName="startSeconds" placeholder="e.g., 00:10"
                                    [ngClass]="{ 'input-error': step.get('startSeconds')?.hasError('required') && step.get('startSeconds')?.touched}">
                                <span class="error-msg"
                                    *ngIf="step.get('startSeconds')?.hasError('required') && step.get('startSeconds')?.touched">
                                    Start Time is required.</span>
                            </div>
                            <div class="input-field time">
                                <span>End Time</span>
                                <input matInput formControlName="endSeconds" placeholder="e.g., 00:30"
                                    [ngClass]="{ 'input-error': step.get('endSeconds')?.hasError('required') && step.get('endSeconds')?.touched}">
                                <span class="error-msg"
                                    *ngIf="step.get('endSeconds')?.hasError('required') && step.get('endSeconds')?.touched">
                                    End Time is required.</span>
                            </div>
                            <mat-icon matTooltip="Delete step" class="delete-icon"
                                (click)="deleteStep(i)">delete</mat-icon>
                        </div>
                        <div class="editor-ai-cont">
                            <div class="custom-rich-editor-cont">
                                <div id="custom-toolbar">
                                    <!-- <button class="ql-insertCircle">
                                    🔵
                                </button>
                                <button class="ql-insertDiamond">
                                    ♦️
                                </button> -->
                                    <!-- <button class="ql-insertWarning">
                                    ⚠️
                                </button> -->
                                    <button class="toolbar-icon" (click)="insertSVG('🔵', i)">🔵</button>
                                    <button class="toolbar-icon" (click)="insertSVG('♦️', i)">♦️</button>
                                    <!-- <button class="toolbar-icon" (click)="insertSVG('➕', i)">➕</button> -->
                                    <button class="toolbar-icon" (click)="insertSVG(svgIcon, i)">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="green" viewBox="0 0 448 512">
                                            <path
                                                d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z" />
                                        </svg>
                                    </button>
                                </div>
                                <quill-editor #quillEditor formControlName="instructions" [modules]="editorModules"
                                    placeholder="Type your Instructions" style="height: 100%;">
                                </quill-editor>
                            </div>
                            <button class="ai-btn" (click)="fetchAISuggestions(i)"><mat-icon>auto_fix_high</mat-icon>
                            </button>
                            <div class="image-upload-container">
                                <div *ngIf="!uploadingSteps[i] && !fetchingImageSteps[i]  && !stepImages[i]" class="upload-container">
                                    <mat-icon>image</mat-icon>
                                    <span>Drag and drop or</span>
                                    <span class="text-blue" (click)="fileInput.click()">Click to
                                        upload</span>
                                    <input #fileInput type="file" accept="image/*" style="display: none"
                                        (change)="onFileSelected($event,i,false)">
                                </div>
                                <div *ngIf="uploadingSteps[i] || fetchingImageSteps[i]" class="uploading-container">
                                    <svg class="hourglass" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 206"
                                        preserveAspectRatio="none">
                                        <path class="middle"
                                            d="M120 0H0v206h120V0zM77.1 133.2C87.5 140.9 92 145 92 152.6V178H28v-25.4c0-7.6 4.5-11.7 14.9-19.4 6-4.5 13-9.6 17.1-17 4.1 7.4 11.1 12.6 17.1 17zM60 89.7c-4.1-7.3-11.1-12.5-17.1-17C32.5 65.1 28 61 28 53.4V28h64v25.4c0 7.6-4.5 11.7-14.9 19.4-6 4.4-13 9.6-17.1 16.9z" />
                                        <path class="outer"
                                            d="M93.7 95.3c10.5-7.7 26.3-19.4 26.3-41.9V0H0v53.4c0 22.5 15.8 34.2 26.3 41.9 3 2.2 7.9 5.8 9 7.7-1.1 1.9-6 5.5-9 7.7C15.8 118.4 0 130.1 0 152.6V206h120v-53.4c0-22.5-15.8-34.2-26.3-41.9-3-2.2-7.9-5.8-9-7.7 1.1-2 6-5.5 9-7.7zM70.6 103c0 18 35.4 21.8 35.4 49.6V192H14v-39.4c0-27.9 35.4-31.6 35.4-49.6S14 81.2 14 53.4V14h92v39.4C106 81.2 70.6 85 70.6 103z" />
                                    </svg>
                                    <span> {{ fetchingImageSteps[i]  ? 'Fetching Image...' : 'Uploading...' }}</span>

                                </div>
                                <div *ngIf="!fetchingImageSteps[i]  && stepImages[i]" class="uploaded-image-container">
                                    <img [src]="stepImages[i]" class="rounded-lg" alt="image">
                                    <!-- <mat-icon class="edit-icon">edit</mat-icon> -->
                                    <input #fileInput type="file" accept="image/*" style="display: none" (change)="onFileSelected($event,i,true)">
                                    <button class="mat-button mat-primary mat-raised-button" (click)="fileInput.click()">Change
                                </button>
                                </div>
                            </div>
                            <ng-template #suggestionDialog let-data>
                                <h2 mat-dialog-title>AI Suggestions</h2>
                                <mat-dialog-content>
                                    <div class="suggestion-item-original">
                                        <strong>Your Text:</strong>
                                        <span>{{dialogData.originalText}}</span>
                                    </div>
                                    <div class="suggestions">
                                        <strong>Suggestions:</strong>
                                        <div class="ai-loader" style="text-align: center;" *ngIf="dialogData.loading;">
                                            <mat-spinner diameter="40"></mat-spinner>
                                            <span class="ms-2">Fetching Suggestions...</span>
                                        </div>
                                        <ng-container *ngIf="!dialogData.loading">
                                            <ng-container *ngIf="dialogData.suggestions.length > 0;else noSuggestions">
                                                <div *ngFor="let suggestion of dialogData.suggestions"
                                                    class="suggestion-item"
                                                    (click)="applySuggestion(suggestion, dialogData.stepIndex)">
                                                    <div [innerHTML]="sanitizeHTML(suggestion.typedText)"></div>
                                                </div>
                                            </ng-container>
                                            <ng-template #noSuggestions>
                                                <p>No suggestions available at the moment.</p>
                                            </ng-template>
                                        </ng-container>
                                    </div>
                                </mat-dialog-content>
                                <mat-dialog-actions align="end" *ngIf="dialogData.suggestions.length > 0">
                                    <button mat-raised-button color="primary"
                                        (click)="applySuggestion(dialogData.originalText,dialogData.stepIndex )">Keep
                                        Existing</button>
                                </mat-dialog-actions>
                            </ng-template>
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-row" style="align-self: flex-end;gap: 10px;">
                    <button class="mat-button mat-primary mat-raised-button save-btn" [disabled]="!enableSave"
                        (click)="saveSteps()">
                        Save
                    </button>
                    <button style="background-color: #f55656;" class="mat-button mat-primary mat-raised-button"
                        (click)="deleteSop(formData?.id)">Delete
                        SOP
                    </button>
                </div>
            </div>
        </ng-template>
    </ng-container>
</div>